import styled from '@emotion/styled';

const ContentContainer: React.ElementType = styled.div<{
  borderRadius?: boolean;
  noPadding?: boolean;
  noOverflow?: boolean;
}>`
  margin-bottom: 1.5rem;
  box-shadow: 0px 0px 8px #d7d7d7;
  border: 1px solid #e4e7ec;
  padding: ${props => (props.noPadding ? '0' : '1rem')};
  background-color: #fff;
  border-radius: ${props => (props.borderRadius ? `6px` : '0')};
  overflow: ${props => (props.noOverflow ? 'hidden' : 'initial')};
`;

export default ContentContainer;
